import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { ref, onValue, remove } from "firebase/database";
import CategoryForm from "./CategoryForm";

// التحقق من Electron
const isElectron = () => window.electronAPI !== undefined;

const cardStyle = {
  padding: "12px",
  marginBottom: "8px",
  background: "#f9fafb",
  borderRadius: "8px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const CategoriesPage = ({ uid }) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  // تحميل التصنيفات (نفس الشكل القديم مع إضافة SQLite)
  const loadCategories = async () => {
    if (!uid) return;
    
    setLoading(true);
    
    if (isElectron()) {
      // ✅ في Electron: اقرأ من SQLite أولاً
      const sqliteCategories = await window.electronAPI.getCategories();
      if (sqliteCategories && sqliteCategories.length > 0) {
        setCategories(sqliteCategories);
        setLoading(false);
      }
    }
    
    // ✅ الاستماع لـ Firebase (للمزامنة)
    const categoriesRef = ref(db, `distributors/${uid}/categories`);
    const unsubscribe = onValue(categoriesRef, async (snapshot) => {
      const data = snapshot.val();
      let categoriesArray = [];
      
      if (data) {
        categoriesArray = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        
        // ✅ مزامنة مع SQLite
        if (isElectron() && categoriesArray.length > 0) {
          await window.electronAPI.syncCategories(categoriesArray);
        }
      }
      
      setCategories(categoriesArray);
      setLoading(false);
    });

    return () => unsubscribe();
  };

  // حذف تصنيف (نفس الشكل القديم مع إضافة SQLite)
  const handleDelete = async (categoryId) => {
    if (!window.confirm("Supprimer cette catégorie ?")) return;
    
    try {
      // ✅ حذف من Firebase
      await remove(ref(db, `distributors/${uid}/categories/${categoryId}`));
      
      // ✅ حذف من SQLite (إذا كنا في Electron)
      if (isElectron()) {
        await window.electronAPI.deleteCategory(categoryId);
      }
      
      // ✅ إعادة تحميل القائمة
      await loadCategories();
      
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
      alert("Erreur lors de la suppression");
    }
  };

  useEffect(() => {
    if (uid) {
      loadCategories();
    }
  }, [uid]);

  if (loading && categories.length === 0) {
    return <div style={{ padding: 24 }}>Chargement...</div>;
  }

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <h2>Mes Catégories</h2>

      {/* مؤشر وضع التشغيل (جديد) */}
      {isElectron() && (
        <div style={{
          background: "#e0f2fe",
          padding: "8px 12px",
          borderRadius: 6,
          marginBottom: 16,
          fontSize: 12,
        }}>
          💾 Mode hors ligne - Les données sont en SQLite
        </div>
      )}

      {uid ? (
        <>
          <CategoryForm
            uid={uid}
            editCategoryData={selectedCategory}
            onFinish={() => setSelectedCategory(null)}
            onCategoryChange={loadCategories}  // ✅ إضافة تحديث القائمة
          />

          {/* ✅ القائمة بنفس الشكل القديم */}
          <div>
            {categories.length === 0 ? (
              <p>Aucune catégorie.</p>
            ) : (
              categories.map((category) => (
                <div key={category.id} style={cardStyle}>
                  <div>
                    <strong>{category.name || "Sans nom"}</strong>
                    {/* ✅ إذا كان لديك Ref في القائمة، احذفه أو اتركه */}
                    {category.ref && (
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        Ref: {category.ref}
                      </div>
                    )}
                  </div>

                  <div>
                    <button 
                      onClick={() => setSelectedCategory(category)}
                      style={{
                        padding: "6px 12px",
                        border: "1px solid #d1d5db",
                        borderRadius: "6px",
                        background: "white",
                        cursor: "pointer",
                      }}
                    >
                      Modifier
                    </button>
                    <button
                      onClick={() => handleDelete(category.id)}
                      style={{
                        marginLeft: "8px",
                        background: "#ef4444",
                        color: "#fff",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                    >
                      Supprimer
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      ) : (
        <p>Chargement de l'utilisateur...</p>
      )}
    </div>
  );
};

export default CategoriesPage;